import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptService {

  constructor() {  }

  public async encrypt(key: string, data: any) {

    try {
      const bytes = CryptoJS.AES.encrypt(data, key).toString();

      return bytes;
    } catch (error) {

      return null;
    }
  }

  public async decrypt(key: string, data: any) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, key);

      if (bytes.toString()) {
        return bytes.toString(CryptoJS.enc.Utf8);
      }

      return null;
    } catch (error) {

      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/crypt.service.ts